import { type ReactNode, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSegment } from '@repo/poly-hooks/segment';
import { PhoneIdentification } from '../../svgs';
import styles from './started-on-phone.module.css';

export function StartedOnPhone(): ReactNode {
  const segment = useSegment();

  useEffect(() => {
    segment.track('onboarding_idnow_mobile_flow_started');
  }, [segment]);

  return (
    <div className={styles.wrapper} data-test-idnow-step-started-on-phone>
      <div className={styles.container}>
        <div className="mb-32">
          <PhoneIdentification className={styles.icon} />
        </div>
        <h1 className="heading-section mb-16" data-test-idnow-started-on-phone-step-title>
          <FormattedMessage id="qonto-idnow.waiting-mobile.title" />
        </h1>
        <p className="body-standard mb-32" data-test-idnow-started-on-phone-step-subtitle>
          <FormattedMessage id="qonto-idnow.waiting-mobile.subtitle" />
        </p>
      </div>
    </div>
  );
}
